export const FETCH_CLIENTS_COMPLETED = 'FETCH_CLIENTS_COMPLETED';
export const FETCH_CLIENTS_ERROR = 'FETCH_CLIENTS_ERROR';
export const FETCH_CLIENTS_STARTED = 'FETCH_CLIENTS_STARTED';

export const UPDATE_CLIENTS_CURRENT_PAGE = 'UPDATE_CLIENTS_CURRENT_PAGE';
export const UPDATE_CLIENTS_PAGE_SIZE = 'UPDATE_CLIENTS_PAGE_SIZE';

export const ADD_CLIENT_SEARCH = 'ADD_CLIENT_SEARCH';
export const CLEAR_CLIENT_SEARCH = 'CLEAR_CLIENT_SEARCH';

export const CLEAR_CLIENT_COLUMN_SORT = 'CLEAR_CLIENT_COLUMN_SORT';
export const UPDATE_CLIENT_COLUMN_SORT = 'UPDATE_CLIENT_COLUMN_SORT';
